<template>
    <div>
        <v-alert v-if="dResumenPagoJson.length==0" outlined type="warning" text border="left">
            <strong>No hay registros para mostrar.</strong>
        </v-alert>
        <v-card v-else v-for="item in dResumenPagoJson" :key="item.IdSeccion">
            <v-card-title color="primary" style="background-color:#BBDEFB; color:#0277BD" class="mt-3 pa-1">
                <span @click="fuCopy(item.IdSeccion)" :title="item.IdSeccion">Nivel: {{item.Seccion}}</span>
                <v-icon @click="fuCopy(item.IdMatricula)" :title="item.IdMatricula" color="blue">{{fuTurnoIconoLocal(item.Turno)}}</v-icon>
            </v-card-title>
            <v-simple-table dense>
                <template v-slot:default>
                    <thead>
                        <tr>
                            <th class="text-left blue--text">Cuota</th>
                            <th class="text-left blue--text">F. Programada</th>
                            <th class="text-center blue--text">Monto Prog</th>
                            <th class="text-center blue--text">Descuento</th>
                            <th class="text-center blue--text">Monto Pagado</th>
                            <th class="text-right blue--text">Deuda</th>
                            <th class="text-center blue--text">F. Pago</th>
                            <th class="text-center blue--text">Nro. Boleta</th>
                            <th class="text-center blue--text">Acción</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="item2 in item.pago" :key="item2.IDPagoPeriodicoMatricula" :class="fuPagoColor(item2) === 'error' ? 'deuda':''" >
                            <td @click="fuCopy(item2.IDPagoPeriodicoMatricula)" :title="item2.IDPagoPeriodicoMatricula">{{ item2.Mes }}</td>
                            <td>{{ item2.FechaProg.substring(0,10) }}</td>
                            <td class="text-center">{{ item2.MontoProg }}</td>
                            <td class="text-center">{{ item2.Descuento>0 ? item2.Descuento : "" }}</td>
                            <td class="text-center">{{ item2.MontoPagado>0 ? item2.MontoPagado : "" }}</td>
                            <td class="text-right">{{ fuPagoDeuda(item2) }} <v-icon :color="fuPagoColor(item2)">{{fuPagoIcon(item2)}}</v-icon></td>
                            <td class="text-center">{{ item2.FechaPagos }}</td>
                            <td v-if="fuPagoEliminarShow(item2, item.Seccion.substring(7,8))"  class="text-center">
                                <v-btn @click="fuPagoEliminar(item2.IDPagoPeriodicoMatricula)" icon color="error"><v-icon>delete</v-icon> Eliminar</v-btn>
                            </td>
                            <td v-else class="text-center">{{ item2.NoDocumentoPago }}</td>
                            <td class="text-center">
                                <v-btn @click="fuQuitarMora(item2)" v-if="fuQuitarMoraShow(item2)" color="blue-grey" outlined elevation="2" x-small><v-icon>money_off_csred</v-icon> Eliminar Mora</v-btn>
                            </td>
                        </tr>
                    </tbody>
                </template>
            </v-simple-table>
        </v-card>
        <div class="pt-5 d-flex justify-center">
            <v-btn @click="fuLoad(pIdAlumno)" outlined color="teal accent-4"><v-icon>sync</v-icon> Actualizar</v-btn>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import gql from 'graphql-tag';
import {mapState} from 'vuex';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';
import {fuTurnoIcono} from '@/helpers/index.js';

export default {
    name: 'CResumenPago',
    props: ['pIdAlumno'],
    mounted(){
    	this.fuLoad(this.pIdAlumno);
    },
    data: () => ({
        dIsLoading: false,
        dResumenPago: [],
        dResumenPagoJson: [],
        dNivelesNoAprobados: [],
        dIdSeccions: [],
    }),
    watch: {
        pIdAlumno(val){
            if(val)
                this.fuLoad(val);
        },
    },
    computed: {
        ...mapState(['ssUser']),
    },
    methods: {
        fuCopy(pCopy){
            navigator.clipboard.writeText(pCopy);
        },
        fuPagoDeuda(vItem){            
            let vPagado = vItem.MontoProg - vItem.Descuento - vItem.MontoPagado;
            return vPagado<=0 ? 0: vPagado;
        },
        fuPagoColor(vItem){
            let vPagado = vItem.MontoProg - vItem.Descuento - vItem.MontoPagado;

            let vToday = new Date();
            let vFecha = new Date(vItem.FechaProg);

            if(vPagado<=0)
                return 'success';
            else{
                if(vToday > vFecha)
                    return 'error';
                else
                    return 'primary';
            }
        },
        fuPagoIcon(vItem){
            let vPagado = vItem.MontoProg - vItem.Descuento - vItem.MontoPagado;

            let vToday = new Date();
            let vFecha = new Date(vItem.FechaProg);

            if(vPagado<=0)
                return 'sentiment_very_satisfied';
            else{
                if(vToday > vFecha)
                    return 'sentiment_very_dissatisfied';
                else
                    return 'sentiment_neutral';
            }
        },
        async fuLoad(vIdAlumno){
            this.dIsLoading = true;
            let vIdSeccions ="";
            try {
                const response = await this.$apollo.query({
                    query: gql`query load($IdAlumno: Int!, $IdAlumnoID: ID!){
                        resumenpago(IdAlumno: $IdAlumno){
                            IDPagoPeriodicoMatricula
                            IdMatricula
                            IdSeccion
                            Seccion
                            Turno
                            Mes
                            FechaProg
                            MontoProg
                            Descuento
                            MontoPagado
                            FechaPagos
                            NoDocumentoPago
                        }
                        matcursosministerioEgresadoDetalle(IdAlumno: $IdAlumnoID){
                            Nivel
                            IdMatricula
                        }
                    }`,
                    variables: {
                        IdAlumno: vIdAlumno,
                        IdAlumnoID: vIdAlumno
                    },
                    fetchPolicy: 'no-cache'
                })
                this.dNivelesNoAprobados = this.filtrarNivelesUnicosSinMatricula(response.data.matcursosministerioEgresadoDetalle);
                
                vIdSeccions = [...new Set(response.data.resumenpago.map(item => item.IdSeccion))].join(',');//solo IdSeccion unicos

                const resultado = response.data.resumenpago.reduce((acc, item) => {
                    const { IdMatricula, IdSeccion, Seccion, Turno, IDPagoPeriodicoMatricula, Mes, FechaProg, MontoProg, Descuento, MontoPagado, FechaPagos, NoDocumentoPago } = item;

                    // Verificamos si la sección ya existe en el objeto
                    if (!acc[IdSeccion]) {
                        acc[IdSeccion] = {
                            IdMatricula,
                            IdSeccion,
                            Seccion,
                            Turno,
                            pago: []
                        };
                    }
                    // Agregamos el pago a la lista de pagos de la sección
                    acc[IdSeccion].pago.push({
                        IdSeccion,
                        IDPagoPeriodicoMatricula,
                        Mes,
                        FechaProg,
                        MontoProg,
                        Descuento,
                        MontoPagado,
                        FechaPagos,
                        NoDocumentoPago
                    });

                    return acc;
                }, {});
                // Convertimos el objeto en un array y lo ordenamos por IdSeccion en orden descendente
                this.dResumenPagoJson = Object.values(resultado).sort((a, b) => b.IdSeccion - a.IdSeccion);

            } catch (error) {
                console.log(error);
                Swal.fire('¡ ERROR !', 'Problema de Conexión.', 'error');
            } finally {
                this.dIsLoading = false
                if(vIdSeccions != "")
                    this.fumatseccionByIdSeccions(vIdSeccions);
            }
        },
        async fumatseccionByIdSeccions(vIdSeccions) {
            try {
                const response = await this.$apollo.query({
                    query: gql`query matseccionByIdSeccions($IdSeccions: String!){
                        matseccionByIdSeccions(IdSeccions: $IdSeccions){
                            IdSeccion
                            FechaFin
                        }
                    }`,
                    variables: {
                        IdSeccions: vIdSeccions,
                    },
                    fetchPolicy: 'no-cache'
                });
                this.dIdSeccions = response.data.matseccionByIdSeccions;
            } catch (error) {
                Swal.fire({ icon: 'error', title: '¡ ERROR !', html: 'Error de consulta'})
            } finally {
            }
        },
        fuTurnoIconoLocal(vTurno){
            return fuTurnoIcono(vTurno);
        },
        filtrarNivelesUnicosSinMatricula(niveles) {
            const nivelesAgrupados = niveles.reduce((acc, item) => {
                if (!acc[item.Nivel]) {
                    acc[item.Nivel] = [];
                }
                acc[item.Nivel].push(item.IdMatricula);
                return acc;
            }, {});

            return Object.entries(nivelesAgrupados)
                .filter(([_, idMatriculas]) => idMatriculas.every(id => id === null))
                .map(([nivel]) => Number(nivel));
        },
        fuPagoEliminarShow(vItem, vNivel){
            let vToday = new Date();
            let vSeccion = this.dIdSeccions.find(item => item.IdSeccion == vItem.IdSeccion);
            if(!vSeccion) return false;
            let vFecha = new Date(vSeccion.FechaFin);

            let vNivelNoAprobado = false;
            if(this.dNivelesNoAprobados.length == 0)
                vNivelNoAprobado = true;
            else
                vNivelNoAprobado = this.dNivelesNoAprobados.includes(parseInt(vNivel))

            return vItem.MontoProg - vItem.Descuento - vItem.MontoPagado > 0 && vNivelNoAprobado && vToday > vFecha ? true:false;
        },
        fuQuitarMoraShow(vItem){
            let vToday = new Date();
            let vFecha = new Date(vItem.FechaProg);
            return vItem.Mes == 'MATRICULA' && vItem.FechaPagos == 'POR PAGAR' && vToday > vFecha ? true:false;
        },
        fuPagoEliminar(vIDPagoPeriodicoMatricula){
            try {
                Swal.fire({
                    icon: 'question',
                    title: '¿Estás seguro de ELIMINAR?',
                    text: "Registre justificación",
                    showCancelButton: true,
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Si, eliminar',
                    cancelButtonText: 'No',
                    allowOutsideClick: false,
                    showLoaderOnConfirm: true,
                    input: "text",
                    preConfirm: (vJustificacion) => {
                        if(!vJustificacion)
                            Swal.fire('¡ ERROR !', 'Ingrese Justificación.', 'error');
                        else
                            this.spuINGPAGOPERIODICOMATRICULA_ANULACIONDEUDA(vIDPagoPeriodicoMatricula, vJustificacion)
                    },
                }).then((result) => {
                })
            } catch (error) {
                console.log(error);
                Swal.fire('¡ ERROR !', 'Error al eliminar.', 'error');
            }
        },
        async spuINGPAGOPERIODICOMATRICULA_ANULACIONDEUDA(vIDPagoPeriodicoMatricula, vJustificacion) {
            try {
                const response = await this.$apollo.mutate({
                    mutation: gql`mutation spuINGPAGOPERIODICOMATRICULA_ANULACIONDEUDA($JUSTIFICACION: String, $USUARIOMOD: String, $TIPOMOD: String, $IDPAGOPERIODICOMATRICULA: String){
                        spuINGPAGOPERIODICOMATRICULA_ANULACIONDEUDA(JUSTIFICACION: $JUSTIFICACION, USUARIOMOD: $USUARIOMOD, TIPOMOD: $TIPOMOD, IDPAGOPERIODICOMATRICULA: $IDPAGOPERIODICOMATRICULA){
                            error
                            message
                            data
                        }
                    }`,
                    variables: {
                        JUSTIFICACION: vJustificacion,
                        USUARIOMOD: this.ssUser.IdPersonal,
                        TIPOMOD: "REPITENCIA",
                        IDPAGOPERIODICOMATRICULA: vIDPagoPeriodicoMatricula
                    }
                });

                if(response.data){
                    Swal.fire({ icon: 'success', title: 'Correcto', html: 'Registro eliminado' });
                } else {
                    Swal.fire({ icon: 'error', title: '¡ ERROR !', html: 'Registro incorrecto'})
                }
            } catch (error) {
                Swal.fire({ icon: 'error', title: '¡ ERROR !', html: 'Registro incorrecto'})
            } finally {
                this.fuLoad(this.pIdAlumno);
            }
        },
        fuQuitarMora(vItem){
            try {
                Swal.fire({
                    icon: 'question',
                    title: '¿Estás seguro de ELIMINAR?',
                    text: "Registre justificación",
                    showCancelButton: true,
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Si, eliminar',
                    cancelButtonText: 'No',
                    allowOutsideClick: false,
                    showLoaderOnConfirm: true,
                    input: "text",
                    preConfirm: (vJustificacion) => {
                        if(!vJustificacion)
                            Swal.fire('¡ ERROR !', 'Ingrese Justificación.', 'error');
                        else
                            this.spuINGQUITARMORA(vItem, vJustificacion)
                    },
                }).then((result) => {
                })
            } catch (error) {
                console.log(error);
                Swal.fire('¡ ERROR !', 'Error al eliminar.', 'error');
            }
        },
        async spuINGQUITARMORA(vItem, vJustificacion) {
            try {
                const response = await this.$apollo.mutate({
                    mutation: gql`mutation spuINGQUITARMORA($IdAlumno: Int!, $IDPagoPeriodicoMatricula: Int!, $usuario: String!, $tipo: String!, $Justificacion: String!){
                        spuINGQUITARMORA(IdAlumno: $IdAlumno, IDPagoPeriodicoMatricula: $IDPagoPeriodicoMatricula, usuario: $usuario, tipo: $tipo, Justificacion: $Justificacion, ){
                            error
                            message
                            data
                        }
                    }`,
                    variables: {
                        IdAlumno: this.pIdAlumno,
                        IDPagoPeriodicoMatricula: vItem.IDPagoPeriodicoMatricula,
                        usuario: this.ssUser.IdPersonal,
                        tipo: "MatExt",
                        Justificacion: vJustificacion
                    }
                });

                if(response.data){
                    Swal.fire({ icon: 'success', title: 'Correcto', html: 'Mora eliminada.' });
                } else {
                    Swal.fire({ icon: 'error', title: '¡ ERROR !', html: 'Registro incorrecto'})
                }
            } catch (error) {
                Swal.fire({ icon: 'error', title: '¡ ERROR !', html: 'Registro incorrecto'})
            } finally {
            }
        },
        async fuGetReporte(pReport, pIdMatricula){
            const params = {
                IdMatricula: pIdMatricula
            }

            let url = 'https://tamboreportserver.khipu.edu.pe/ReportServer/?/Khipu/Secretaria%20Academica/' + pReport + '&rs:Command=Render&rs:Format=PDF';
            Object.keys(params).forEach(key => {
                url += '&' + key + '=' + params[key];
            });

            const response = await axios.get(url, {
                responseType: 'arraybuffer',
                headers: {
                    'Authorization': 'Basic ' + Buffer.from('Khipu\\Administrador:@khipu@ayllu40').toString('base64'),
                    'Accept': 'application/pdf'
                }
            })
            return response.data
        },
    }
}
</script>
<style scoped>
tr:nth-child(even) {
    background-color: #E3F2FD;
}
.deuda{
    background-color: #FFCDD2 !important;
}
</style>
